<template>
  <div class="assets">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang113') }}</span>
    </div>
    <div class="pd">
      <div class="">
        <div class="total_box">
          <div>
            <!-- <span v-if="type == 1" class="text">{{ $t('lang161') }}(USDT)</span> -->
            <span class="text f"
              >{{ $t('lang161') }}(<svg width="12" height="22" viewBox="30 0 50 96" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M70,35
           C56,28 38,40 40,54
           C40,64 50,74 70,66"
                  fill="none"
                  stroke="rgba(255, 255, 255, 0.8)"
                  stroke-width="6"
                  stroke-linecap="round"
                />
                <line x1="52" y1="29" x2="52" y2="73" stroke="rgba(255, 255, 255, 0.8)" stroke-width="5.2" stroke-linecap="round" />
                <line x1="63" y1="29" x2="63" y2="73" stroke="rgba(255, 255, 255, 0.8)" stroke-width="5.2" stroke-linecap="round" />
              </svg>
              )
            </span>
          </div>
          <div class="total">
            <span>{{ Math.floor(assets * 100) / 100 || 0 }}</span>
          </div>
          <div class="bo">
            <!-- <img src="@/assets/images/chance.png" class="icon" />
            <span>{{ $t('lang140') }}</span> -->
          </div>
          <div @click="navigation('withdrawRecord')" class="mx">{{ $t('lang122') }}</div>
        </div>

        <div class="list">
          <div class="box">
            <div class="box_item">
              <span class="left">{{ $t('lang123') }}</span>
              <van-field v-model="amount" :placeholder="$t('lang119')" class="input" input-align="right" />
            </div>
            <div class="box_item">
              <span class="left">{{ $t('lang124') }}</span>
              <span>{{ $t('lang126') }}</span>
            </div>
            <div class="box_item">
              <span class="left">{{ $t('lang125') }}</span>
              <van-field v-model="out_address" type="textarea" style="height: 48px" disabled class="input" input-align="right" />
            </div>
          </div>
        </div>
        <div class="buy" @click="withdrawCash">
          <van-button class="buy_btn" type="primary">{{ $t('lang117') }}</van-button>
        </div>
        <div class="tips">
          <div>{{ $t('lang116') }}</div>
          <div v-html="dataInfo.describe"></div>
        </div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" class="loading" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';
import Web3 from 'web3';
import { Dialog, Notify, Toast } from 'vant';
export default {
  data() {
    return {
      page: 0,
      total: 1,
      assets: 0,
      amount: '',
      // type: 1, // 1udst奖励 2teac奖励
      out_address: '',
      dataInfo: {},
      show: false,
    };
  },
  mounted() {
    this.withdrawInfo();
    this.getUserInfo();
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    navigation(name) {
      this.$router.push({ name });
    },
    changeNav(item, index) {
      this.navIndex = index;
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd hh:mm:ss');
    },
    withdrawInfo() {
      homeApi.withdrawInfo().then(res => {
        if (res.code == 200) {
          this.dataInfo = res.data;
        } else {
        }
      });
    },
    getUserInfo() {
      homeApi.getUserInfo().then(res => {
        if (res.code == 200) {
          this.assets = res.data.balance;
          this.out_address = res.data.address;
        } else {
        }
      });
    },
    withdrawCash() {
      if (!this.amount) {
        this.$toast(this.$t('lang165'));
        return;
      }
      if (!this.out_address) {
        this.$toast(this.$t('lang118'));
        return;
      }
      // if (this.type == 1) {
      //   if (this.amount > this.dataInfo.usdt * 1) {
      //     this.$toast(this.$t('lang167'));
      //     return;
      //   }
      // } else {
      if (this.amount > this.assets * 1) {
        this.$toast(this.$t('lang167'));
        return;
      }
      // }
      if (this.amount < this.dataInfo.withdraw_min_amount * 1) {
        this.$toast(`${this.$t('lang166')} ${this.dataInfo.withdraw_min_amount}`);
        return;
      }
      let _this = this;
      Dialog.confirm({
        title: _this.$t('lang136'),
        message: _this
          .$t('lang448')
          .replace('XX', _this.amount)
          .replace(
            'CC',
            `<svg width="12" height="22" viewBox="28 -20 50 96" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M70,35
           C56,28 38,40 40,54
           C40,64 50,74 70,66"
                    fill="none"
                    stroke="#646566"
                    stroke-width="6"
                    stroke-linecap="round"
                  />
                  <line x1="52" y1="29" x2="52" y2="73" stroke="#646566" stroke-width="5.2" stroke-linecap="round" />
                  <line x1="63" y1="29" x2="63" y2="73" stroke="#646566" stroke-width="5.2" stroke-linecap="round" />
                </svg>`
          ),
        confirmButtonText: _this.$t('lang111'),
        cancelButtonText: _this.$t('lang135'),
      })
        .then(() => {
          _this.show = true;
          let web3 = new Web3(window.web3.currentProvider);
          web3.eth.personal
            .sign(web3.utils.fromUtf8('withdraw'), _this.out_address, (err, res) => {
              let params = {
                amount: _this.amount,
                sign: res,
                to_address: _this.out_address,
              };
              homeApi
                .withdrawCash(params)
                .then(res => {
                  _this.show = false;
                  if (res.code == 200) {
                    _this.amount = '';
                    // _this.out_address = '';
                    _this.getUserInfo();
                    Notify({ type: 'success', message: res.msg });
                  } else {
                    Notify({ message: res.msg });
                  }
                })
                .catch(err => {
                  _this.show = false;
                });
            })
            .catch(err => {
              _this.$toast(err);
              _this.show = false;
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 15px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.f {
  display: flex;
  align-items: center;
}
.assets {
  min-height: 100vh;
  padding: 50px 0 0;
  // background-color: #fafbfc;
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }
  .pd {
    padding: 4px;
    margin-top: 4px;
    // background-color: #fff;
  }
  .total_box {
    position: relative;
    display: flex;
    // align-items: center;
    flex-direction: column;
    justify-content: space-between;
    // position: relative;
    font-size: 13px;
    color: #fff;
    height: 140px;
    // border-radius: 16px;
    padding: 20px 20px;
    box-sizing: border-box;
    border-radius: 10px;
    margin: 10px;
    background: linear-gradient(to right, #1ab986, #25d7bb);

    .total {
      font-size: 28px;
      // text-align: center;
      padding-top: 10px;
    }
    .bo {
      font-size: 12px;
      display: flex;
      align-items: center;
      color: rgba(#fff, 0.8);
      margin: 10px 10px 0 0;

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
        border-radius: 50%;
        padding: 4px;
        background-color: rgba(#000, 0.1);
      }
    }
    .mx {
      position: absolute;
      right: 20px;
      width: fit-content;
      font-size: 11px;
      color: rgba(#f7f7f7, 0.9);
      padding: 2px 12px;
      border-radius: 10px;
      background-color: rgba(#000, 0.1);
    }
    .text {
      color: rgba(#fff, 0.8);
    }
    .buy {
      position: absolute;
      right: 14px;
      bottom: 14px;

      &_btn {
        color: #29b286;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background-color: #ffffff;
        border: none;
        padding: 0 16px;
        white-space: nowrap;
        border-radius: 30px;
      }
    }
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 60px 14px;
    color: #888;
  }
  .list {
    border-radius: 20px;
    padding: 0 20px;
    margin-top: 16px;
    background-color: #fff;
    margin: 16px 6px;

    .box {
      width: 100%;
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
      padding: 18px 0 18px;
      .box_item:last-child {
        border-bottom: none;
        align-items: flex-start;
      }
      &_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 0;
        border-bottom: 0.5px solid rgba(190, 190, 190, 0.15);

        .key {
          color: #aaa;
          font-size: 12px;
        }
        .left {
          font-size: 13px;
        }
        .mobile {
          font-size: 14px;
          color: #000;
          font-weight: 550;
        }
        .input {
          width: 180px;
        }

        /deep/ .van-field__control:disabled {
          color: #000 !important;
          -webkit-text-fill-color: #000 !important;
        }
      }
    }
  }
  .buy {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    &_btn {
      width: 80%;
      height: 46px;
      line-height: 46px;
      font-size: 14px;
      background-color: #29b286;
      border: none;
      padding: 0 10px;
      white-space: nowrap;
      border-radius: 30px;
    }
  }
  .tips {
    color: #aaa;
    font-size: 12px;
    line-height: 180%;
    padding: 14px;
  }
}
.wrapper {
  // display: flex;
  // justify-content: center;
  .loading {
    position: absolute;
    left: 46%;
    top: 46%;
  }
}
</style>